import { render, staticRenderFns } from "./QuestionQuizView.vue?vue&type=template&id=56ca1b8a&scoped=true"
import script from "./QuestionQuizView.vue?vue&type=script&lang=js"
export * from "./QuestionQuizView.vue?vue&type=script&lang=js"
import style0 from "./QuestionQuizView.vue?vue&type=style&index=0&id=56ca1b8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ca1b8a",
  null
  
)

export default component.exports